{
  "title": "Forest Friends Floating",
  "titleIsWorkingTitle": true,
  "subtitle": "Fluss-Autobattler",
  "placeholderText": "Die Werkstatt steht. Bald legen hier die ersten Freunde an."
}
